import {
  TQuestionnairesState,
  TQuestionnairesActions,
  TQuestionnaireDetail,
} from '../../types/questionnaires';
import { TGetQuestionnairesParams } from '../../types/member-api';

export const questionnairesActionTypes = {
  GET_QUESTIONNAIRES_REQUEST: 'QUESTIONNAIRES/GET_QUESTIONNAIRES_REQUEST',
  GET_QUESTIONNAIRES_SUCCESS: 'QUESTIONNAIRES/GET_QUESTIOONAIRES_SUCCESS',
  SET_QUESTIONNAIRE_DETAIL: 'QUESTIONNAIRES/SET_QUESTIONNAIRE_DETAIL',
} as const;

const initialState: TQuestionnairesState = {
  questionnaires: [],
  questionnaireDetail: null,
};

export default (
  state: TQuestionnairesState = initialState,
  action: TQuestionnairesActions,
): TQuestionnairesState => {
  switch (action.type) {
    case questionnairesActionTypes.GET_QUESTIONNAIRES_SUCCESS:
      return {
        ...state,
        questionnaires: action.payload,
      };

    case questionnairesActionTypes.SET_QUESTIONNAIRE_DETAIL:
      return {
        ...state,
        questionnaireDetail: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  setQuestionnaireDetail: (payload: TQuestionnaireDetail) => ({
    payload,
    type: questionnairesActionTypes.SET_QUESTIONNAIRE_DETAIL,
  }),
  getQuestionnairesRequest: (providerId: string, id: string) => ({
    payload: {
      providerId,
      id,
    },
    type: questionnairesActionTypes.GET_QUESTIONNAIRES_REQUEST,
  }),
};
